import React, { useState, useEffect } from 'react';
import { ScrollView, View } from 'react-native';
import {
  Card, Paragraph, Colors, Checkbox, Button, Portal, Dialog,
} from 'react-native-paper';
import { useDispatch, useSelector } from 'react-redux';
import Icon from 'react-native-vector-icons/Ionicons';

import * as WebBrowser from 'expo-web-browser';

import styles from './styles';
import { Alert, AppHeader } from '../../../../components/common';
import { AppButton, AppText } from '../../../../components/form';
import { confirmSubscription } from '../../../../redux/actions/companyActions';

import { API } from '../../../../service/api';

export default function ConfirmLive({ navigation }) {
  const [showAppointments, setShowAppointments] = useState(false);
  const [Agreement, setAgreement] = useState('');
  const [acceptAgreement, setAcceptAgreement] = useState(false);
  const [dialogNotAcceptAgreement, setDialogNotAcceptAgreement] = useState(false);
  const dispatch = useDispatch();

  useEffect(() => {
    API.get('/getseq/contrato_empresa_vigente/1').then((response) => setAgreement(response.data?.data[0]?.arquivo));
  }, []);

  const { companySignUp, availablePlans } = useSelector((state) => state.company);
  const selectedPlan = availablePlans.find((item) => item.id_plano === companySignUp.id_plano);
  const handleConfirmSubscription = () => {
    if (acceptAgreement) {
      return dispatch(confirmSubscription(companySignUp, navigation));
    }
    return setDialogNotAcceptAgreement(true);
  };

  const handleButtonAgreement = async () => {
    await WebBrowser.openBrowserAsync(Agreement);
  };
  return (
    <View>
      <Portal>
        <Dialog visible={dialogNotAcceptAgreement} onDismiss={() => setDialogNotAcceptAgreement(false)}>
          <Dialog.Title>Atenção</Dialog.Title>
          <Dialog.Content>
            <Paragraph>Para continuar você precisa aceitar os nosso contrato.</Paragraph>
          </Dialog.Content>
          <Dialog.Actions>

            <Button
              onPress={() => setDialogNotAcceptAgreement(false)}
            >
              Ok
            </Button>
          </Dialog.Actions>
        </Dialog>
      </Portal>
      <AppHeader navigation={navigation} hasBack title="Confirmar Plano" />
      <ScrollView style={styles.baseScroll}>
        <Card style={styles.cardPlan}>
          <View style={styles.viewTitleCard}>
            <AppText style={styles.textTitleCard}>{selectedPlan.plano}</AppText>
          </View>
          <View style={styles.viewContentCard}>
            <View style={styles.viewLeftContent}>
              <View>
                <AppText style={styles.textPrice}>Valor:</AppText>
                <AppText style={styles.textPriceValue}>{new Intl.NumberFormat('pt-BR', { style: 'currency', currency: 'BRL' }).format(selectedPlan.valor)}</AppText>
              </View>

              <AppButton size="bold" labelStyle={styles.textAgreement} style={styles.buttonAgreement} onPress={handleButtonAgreement} label="Ver Draft do Contrato" />
              <View style={styles.viewAcceptAgreement}>
                <Checkbox
                  status={acceptAgreement ? 'checked' : 'unchecked'}
                  onPress={() => {
                    setAcceptAgreement(!acceptAgreement);
                  }}
                />
                <AppText>Aceitar Draft</AppText>
              </View>
            </View>
            <View style={styles.viewRightContent}>
              {selectedPlan.qtd_colaboradores !== null && (<Paragraph style={styles.paragraphTitle}>{`Até ${selectedPlan.qtd_colaboradores} Colaboradores`}</Paragraph>)}
              <Paragraph>{`${selectedPlan.qtd_aulas_mes} Aulas no Mês`}</Paragraph>
              <Paragraph>{`Plano - ${selectedPlan.duracao_aula} Minutos/Dia`}</Paragraph>
              <Paragraph style={styles.cardTitleText}>{selectedPlan.descricao}</Paragraph>
            </View>
          </View>

          <View />
        </Card>
        <Card style={styles.cardAppointments}>
          <AppButton style={styles.buttonAppointments} onPress={() => setShowAppointments(!showAppointments)}>
            <View style={styles.viewRowCenter}>
              <Icon name={showAppointments ? 'close' : 'add'} style={styles.iconAppointment} />
              <AppText size="bold" style={styles.textAppointment}>{`${showAppointments ? 'Esconder' : 'Mostrar'} Aulas Agendadas`}</AppText>
            </View>
          </AppButton>
          {showAppointments && (
            <View style={styles.viewBase}>
              <AppText style={styles.textDayNHour}>Dias</AppText>
              <View style={styles.groupButtonsHours}>
                { companySignUp.segunda === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Segunda" labelStyle={styles.textBadge} /> }
                { companySignUp.terca === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Terça" labelStyle={styles.textBadge} /> }
                { companySignUp.quarta === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Quarta" labelStyle={styles.textBadge} /> }
                { companySignUp.quinta === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Quinta" labelStyle={styles.textBadge} /> }
                { companySignUp.sexta === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Sexta" labelStyle={styles.textBadge} /> }
                { companySignUp.sabado === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Sábado" labelStyle={styles.textBadge} /> }
                { companySignUp.domingo === 1 && <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label="Domingo" labelStyle={styles.textBadge} /> }
              </View>
              <AppText style={styles.textDayNHour}>Horário</AppText>
              <AppButton style={[styles.buttonBadge, styles.buttonBadgeSelected]} label={companySignUp.horario} labelStyle={styles.textBadge} />
            </View>
          )}
        </Card>
        <Card style={styles.cardPayments}>
          {/* <View style={styles.viewTitleCard}>
            <AppText style={styles.textTitleCard}>Forma de Pagamento</AppText>
          </View>
          <View style={styles.viewPayTypes}>
            <AppButton onPress={() => dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, forma_pagamento: companySignUp.forma_pagamento === 'BOLETO' ? '' : 'BOLETO' } })} style={[styles.buttonBadge, companySignUp.forma_pagamento === 'BOLETO' && styles.buttonBadgeSelected]} label="Boleto" labelStyle={styles.textBadge} />
            <AppButton onPress={() => dispatch({ type: CompanyActions.UPDATE_SIGNUP, companySignUp: { ...companySignUp, forma_pagamento: companySignUp.forma_pagamento === 'PIX' ? '' : 'PIX' } })} style={[styles.buttonBadge, companySignUp.forma_pagamento === 'PIX' && styles.buttonBadgeSelected]} label="PIX" labelStyle={styles.textBadge} />
          </View> */}
          <Alert
            icon="info"
            message="Nossos Consultores irão entrar em contato para enviar o boleto
            ou dados do Pix conforme plano selecionado."
            backgroundColor={Colors.lightBlue800}
          />
          <AppButton
            // disabled={companySignUp.forma_pagamento === ''}
            size="bold"
            labelStyle={styles.textAppointment}
            label="Continuar"
            style={styles.buttonAppointments}
            onPress={handleConfirmSubscription}
          />
        </Card>
      </ScrollView>
    </View>
  );
}
